import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Toaster } from 'sonner';

// Pages
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ProductPage from './pages/ProductPage';
import CartPage from './pages/CartPage';
import SobrePage from './pages/SobrePage';
import ContatoPage from './pages/ContatoPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import OrdersPage from './pages/OrdersPage';
import ComingSoonPage from './pages/ComingSoonPage';
import FaqPage from './pages/FaqPage';
import TermsPage from './pages/TermsPage';
import WishlistPage from './pages/WishlistPage';
import OrderConfirmationPage from './pages/OrderConfirmationPage';
import ProtectedRoute from './components/ProtectedRoute';
import PageTransition from './components/PageTransition';

// Components
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

const PREVIEW_ACCESS_KEY = 'aura-rosa-preview-access';

function AnimatedRoutes() {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
        <Route path="/produtos" element={<PageTransition><ProductsPage /></PageTransition>} />
        <Route path="/produto/:id" element={<PageTransition><ProductPage /></PageTransition>} />
        <Route path="/carrinho" element={<PageTransition><CartPage /></PageTransition>} />
        <Route path="/checkout" element={<PageTransition><Navigate to="/carrinho" replace /></PageTransition>} />
        <Route path="/sobre" element={<PageTransition><SobrePage /></PageTransition>} />
        <Route path="/contato" element={<PageTransition><ContatoPage /></PageTransition>} />
        <Route path="/login" element={<PageTransition><LoginPage /></PageTransition>} />
        <Route path="/register" element={<PageTransition><RegisterPage /></PageTransition>} />
        <Route path="/perfil" element={
          <PageTransition>
            <ProtectedRoute><ProfilePage /></ProtectedRoute>
          </PageTransition>
        } />
        <Route path="/pedidos" element={
          <PageTransition>
            <ProtectedRoute><OrdersPage /></ProtectedRoute>
          </PageTransition>
        } />
        <Route path="/pedido-confirmado" element={<PageTransition><OrderConfirmationPage /></PageTransition>} />
        <Route path="/faq" element={<PageTransition><FaqPage /></PageTransition>} />
        <Route path="/termos-de-uso" element={<PageTransition><TermsPage /></PageTransition>} />
        <Route path="/wishlist" element={
          <PageTransition>
            <ProtectedRoute><WishlistPage /></ProtectedRoute>
          </PageTransition>
        } />
        <Route path="*" element={<PageTransition><Navigate to="/produtos" replace /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  // 🔒 CONTROLE DO COMING SOON
  const isComingSoon = process.env.REACT_APP_COMING_SOON === 'true';
  const previewKey = process.env.REACT_APP_PREVIEW_KEY || 'aurarosa123';

  const params = new URLSearchParams(window.location.search);
  const hasPreviewParam = params.get('preview') === previewKey;
  const hasStoredPreviewAccess =
    window.sessionStorage.getItem(PREVIEW_ACCESS_KEY) === previewKey;
  const hasPreviewAccess = hasPreviewParam || hasStoredPreviewAccess;

  if (hasPreviewParam && !hasStoredPreviewAccess) {
    window.sessionStorage.setItem(PREVIEW_ACCESS_KEY, previewKey);
  }

  // 🔥 ESSENCIAL: NÃO BLOQUEAR ROTAS DE API
  const isApiRoute = window.location.pathname.startsWith('/api');

  // 🚫 BLOQUEIO GLOBAL (COM EXCEÇÃO DA API)
  if (!isApiRoute && isComingSoon && !hasPreviewAccess) {
    return <ComingSoonPage />;
  }

  return (
    <Router>
      <ScrollToTop />
      <Navbar />

      <AnimatedRoutes />

      <Footer />
      <Toaster position="top-center" richColors closeButton />
    </Router>
  );
}

export default App;
